import type { StyleRule } from '@archipro-design/aria';
import { buttonClassName } from '@archipro-design/aria';
import { labelClassName } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const FindNearestSection: StyleRule = ({ theme }) => ({
    fontSize: theme.siteVariables.fontSizes.caption04,
    marginTop: pxToRem(25),
    padding: pxArrayToRem([0, 18]),
    height: pxToRem(59),

    ...theme.siteVariables.textStyles.Heading.Roman55,
    backgroundColor: '#E8E9EB',

    [`& .${buttonClassName}`]: {
        padding: 0,
        color: theme.siteVariables.colorScheme.default?.foreground,
        textUnderlineOffset: '2px',
        marginBottom: 0,

        '&:hover': {
            textDecoration: 'unset',
        },

        [`& .${labelClassName}`]: {
            textDecoration: 'underline',
            fontSize: theme.siteVariables.fontSizes.caption04,
            ...theme.siteVariables.textStyles.Heading.Roman55,
            color: theme.siteVariables.colorScheme.default?.foreground,

            [theme.screen.laptop]: {
                textDecoration: 'unset',
            },
        },
        [`& .${svgIconClassName}`]: {
            '& svg': {
                '& path:first-child': {
                    fill: 'transparent',
                },
            },
        },
    },
});

export const FindNearestText: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.danger[100],

    fontSize: pxToRem(14),
    lineHeight: '125%',
    letterSpacing: theme.siteVariables.letterSpacingNormal,
});

export const LocationsText: StyleRule = () => ({
    whiteSpace: 'nowrap',
});
